const messages: Record<string, string> = {
  DOWNLOAD_FAILED: 'Import failed: the link could not be downloaded.',
  DOWNLOAD_MISSING: 'Import failed: the downloaded video could not be stored.',
  VIDEO_PROBE_FAILED: 'Import failed: the downloaded file is not a readable video.',
};

const importErrorMessage = (code?: string | null): string => (code && messages[code]) || 'Import failed.';

export default importErrorMessage;
